import {
  DeleteReportRequest,
  GetReportsV3Request,
  GetReportsV3Response,
  ReportPlace,
  ReportsApi,
  UpdateReportPlacesV3Request,
} from '@ulysses-inc/harami_api_client'
import { call, put } from 'redux-saga/effects'
import * as notificationServiceActions from 'src/features/notificationService/slice'
import interceptionsActions from 'src/state/ducks/interceptions/actions'
import actions from 'src/state/ducks/reports/reports/actions'
import BaseClient from 'src/state/middleware/saga/baseClient'
import {
  HTTPError,
  handleHTTPError,
} from 'src/state/middleware/saga/handleHttpError'

const {
  getSuccessReports,
  getErrorReports,
  deleteSuccessReport,
  deleteErrorReport,
  updateSuccessReportPlaces,
  updateErrorReportPlaces,
} = actions

const baseClient = new BaseClient()

const getReportsV3Request = (req: GetReportsV3Request) => {
  return baseClient
    .getApi(ReportsApi)
    .getReportsV3(req)
    .then(reports => reports)
    .catch(handleHTTPError)
}

const deleteReportRequest = (req: DeleteReportRequest) => {
  return baseClient.getApi(ReportsApi).deleteReport(req).catch(handleHTTPError)
}

const updateReportPlacesV3Request = (req: UpdateReportPlacesV3Request) => {
  return baseClient
    .getApi(ReportsApi)
    .updateReportPlacesV3(req)
    .catch(handleHTTPError)
}

function* getReports(action: ReturnType<typeof actions.getReports>) {
  try {
    const params: GetReportsV3Request = {
      ...action.request,
      reportFilter: { ...action.filter },
    }
    const response: GetReportsV3Response = yield call(
      getReportsV3Request,
      params,
    )
    yield put(getSuccessReports(response.reports ?? [], response.count ?? 0))
  } catch (error) {
    yield put(interceptionsActions.handleHttpError(error as HTTPError))
    yield put(getErrorReports(error as Error))
  }
}

function* deleteReport(action: ReturnType<typeof actions.deleteReport>) {
  try {
    yield call(deleteReportRequest, { reportId: action.reportId })
    yield put(deleteSuccessReport(action.reportId))
  } catch (error) {
    yield put(interceptionsActions.handleHttpError(error as HTTPError))
    yield put(deleteErrorReport(error as Error))
  }
}

function* updateReportPlaces(
  action: ReturnType<typeof actions.updateReportPlaces>,
) {
  try {
    const reportPlaces: ReportPlace[] = action.reports.map(report => {
      return {
        reportId: report.id,
        name: action.reportPlace.name,
        nodeId: action.reportPlace.nodeId,
      }
    })
    const params: UpdateReportPlacesV3Request = {
      ...action.request,
      updateReportPlace: {
        updateReportPlaces: reportPlaces,
        reportFilter: { ...action.filter },
      },
    }
    const response: GetReportsV3Response = yield call(
      updateReportPlacesV3Request,
      params,
    )
    yield put(
      updateSuccessReportPlaces(response.reports ?? [], response.count ?? 0),
    )
    yield put(
      notificationServiceActions.showNotification({
        message: '現場の付け替えに成功しました',
      }),
    )
  } catch (error) {
    yield put(interceptionsActions.handleHttpError(error as HTTPError))
    yield put(updateErrorReportPlaces(error as Error))
  }
}

export { deleteReport, getReports, updateReportPlaces }
